import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'createNewApplication',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      applicationsCols: [],
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      keyColumn: 'applicationId',
      applications: [],
      noDataFound: false,
      bShowAppTypes: false,
    }
  },
  created() {
    this.$root.$on('create_new_application_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.fillApplicationsCols();
        this.applications = this.dataObj.appData.childApplications;
        this.options.total = this.applications.length;
        this.totalRow = this.applications.length;
        this.noDataFound = this.applications.length === 0;
        this.$root.$emit('datagrid_updated');
      });
    },
    fillApplicationsCols() {
      this.applicationsCols.push({ dataField: 'applicationId', caption: '#' });
      this.applicationsCols.push({ dataField: 'name', caption: this.$t('activities.ApplicationName') });
      this.applicationsCols.push({ dataField: 'groupName', caption: this.$t('applications.Status') });
      this.applicationsCols.push({ dataField: 'comment', caption: this.$t('application.comment') });
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
    },
    onSelectApplication(info) {
      if (info.newRowIndex < 0)
        return;

      var app = info.rows[info.newRowIndex].data;
      if ((app === null) || (app === undefined))
        return;
    },
    onLaunchApplication(info) {
      if (info.newRowIndex < 0)
        return;

      if (!info.data)
        return;

      const url = '/application/' + info.data.applicationId;
      window.open(url, '_blank');
    },
    showAppTypes() {
      if (this.dataObj.readOnly)
        return;
    },
    createApplication(typeId) {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: this.dataObj.appKey,
        TypeId: typeId
      };
      this.$store.state.notifier.asyncBlock(
        axios.post('/CreateNewApplicationActivity/CreateApplication', parameter),
        resp => {
          if (resp.status == 200) {
            this.$alertMsg(this.$t('messages.createNewApplicationSuccess'),2);
            this.applications = resp.data.childApplications;
            this.options.total = resp.data.childApplications.length;
            this.totalRow = resp.data.childApplications.length;
            this.noDataFound = resp.data.childApplications.length === 0;
            this.$root.$emit('datagrid_updated');

            const url = '/application/' + resp.data.newAppId;
            window.open(url, '_blank');
          }
          else {
            this.$alertMsg(resp.data.data.text)
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    completeTask(typeId) {
      if (this.dataObj.readOnly)
        return;

      this.dataObj.typeId = typeId;

      this.dataObj.completeTask();
    }
  },
}
